import { render, staticRenderFns } from "./CategoryListItem.vue?vue&type=template&id=7a606bf7&scoped=true&"
import script from "./CategoryListItem.vue?vue&type=script&lang=js&"
export * from "./CategoryListItem.vue?vue&type=script&lang=js&"
import style0 from "./CategoryListItem.vue?vue&type=style&index=0&id=7a606bf7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a606bf7",
  null
  
)

export default component.exports